import Vue from 'vue';
import Vuex from 'vuex';
import { ENV } from '@/config/env.js';
import SecureLS from 'secure-ls';
import createPersistedState from 'vuex-persistedstate';

import homeProPage from './modules/proHome/homeProPage';
import homeProLegalPage from './modules/proHome/homeProLegalPage';
import auth from './modules/proHome/auth';
import proLoginPage from './modules/proHome/proLoginPage';
import proSignUpPage from './modules/proHome/proSignUpPage';
import proOTPPage from './modules/proHome/proOTPPage';
import proRePassPage from './modules/proHome/proRePassPage';
import usersCodeVerif from './modules/proHome/usersCodeVerif';
import proHomePage from './modules/proHome/proHomePage';
import mainHeaderPlatA from './modules/proHome/mainHeaderPlatA';
import proLegalPage from './modules/proHome/proLegalPage';
import proAccountPage from './modules/proHome/proAccountPage';
import proProfileAPage from './modules/proHome/proProfileAPage';
import proProfileBPage from './modules/proHome/proProfileBPage';
import proProfileCPage from './modules/proHome/proProfileCPage';
import proPatientsAPage from './modules/proHome/proPatientsAPage';
import proPatientsBPage from './modules/proHome/proPatientsBPage';
import proPatientsCPage from './modules/proHome/proPatientsCPage';
import proPatientsCAnamnesisPage from './modules/proHome/proPatientsCAnamnesisPage';
import proPatientsCReport from './modules/proHome/proPatientsCReport';
import anamPermissions from './modules/proHome/anamPermissions';
import notifications from './modules/proHome/notifications';
import anamLineData from './modules/anamCA/anamLineData';
import anamFiliationPersonal from './modules/anamCA/anamFiliationPersonal';
import anamReasonConsultation from './modules/anamCA/anamReasonConsultation';
import anamCAxInterview from './modules/anamCA/anamCAxInterview';
import anamCAxAFSMxPhysicalCond from './modules/anamCA/anamCAxAFSMxPhysicalCond';
import anamCAxAFSMxDysfunction from './modules/anamCA/anamCAxAFSMxDysfunction';
import anamCAxAFSMxPsychomotor from './modules/anamCA/anamCAxAFSMxPsychomotor';
import anamCAxAFSMxClarifications from './modules/anamCA/anamCAxAFSMxClarifications';
import anamCAxAFFxBasicHabits from './modules/anamCA/anamCAxAFFxBasicHabits';
import anamCAxAFFxPhysiolSymptoms from './modules/anamCA/anamCAxAFFxPhysiolSymptoms';
import anamCAxAFFxMuscularSymptoms from './modules/anamCA/anamCAxAFFxMuscularSymptoms';
import anamCAxAFFxClarifications from './modules/anamCA/anamCAxAFFxClarifications';
import anamCAxACGxAttention from './modules/anamCA/anamCAxACGxAttention';
import anamCAxACGxPerception from './modules/anamCA/anamCAxACGxPerception';
import anamCAxACGxMemory from './modules/anamCA/anamCAxACGxMemory';
import anamCAxACGxThoughtPt1 from './modules/anamCA/anamCAxACGxThoughtPt1';
import anamCAxACGxThoughtPt2 from './modules/anamCA/anamCAxACGxThoughtPt2';
import anamCAxACGxThoughtPt3 from './modules/anamCA/anamCAxACGxThoughtPt3';
import anamCAxACGxLanguage from './modules/anamCA/anamCAxACGxLanguage';
import anamCAxACGxClarifications from './modules/anamCA/anamCAxACGxClarifications';
import anamCAxARPxPersonality from './modules/anamCA/anamCAxARPxPersonality';
import anamCAxARPxClarifications from './modules/anamCA/anamCAxARPxClarifications';
import anamCAxAAMxAffectivity from './modules/anamCA/anamCAxAAMxAffectivity';
import anamCAxAAMxClarifications from './modules/anamCA/anamCAxAAMxClarifications';
import anamCAxACOxBehavioral from './modules/anamCA/anamCAxACOxBehavioral';
import anamCAxACOxClarifications from './modules/anamCA/anamCAxACOxClarifications';
import anamCAxAFAxFamiliarPt1 from './modules/anamCA/anamCAxAFAxFamiliarPt1';
import anamCAxAFAxFamiliarPt2 from './modules/anamCA/anamCAxAFAxFamiliarPt2';
import anamCAxAFAxFamiliarPt3 from './modules/anamCA/anamCAxAFAxFamiliarPt3';
import anamCAxAFAxClarifications from './modules/anamCA/anamCAxAFAxClarifications';
import anamCAxASCxSocialPt1 from './modules/anamCA/anamCAxASCxSocialPt1';
import anamCAxASCxSocialPt2 from './modules/anamCA/anamCAxASCxSocialPt2';
import anamCAxASCxSocialPt3 from './modules/anamCA/anamCAxASCxSocialPt3';
import anamCAxASCxSocialPt4 from './modules/anamCA/anamCAxASCxSocialPt4';
import anamCAxASCxSocialPt5 from './modules/anamCA/anamCAxASCxSocialPt5';
import anamCAxASCxSocialPt6 from './modules/anamCA/anamCAxASCxSocialPt6';
import anamCAxASCxClarifications from './modules/anamCA/anamCAxASCxClarifications';
import anamCAxASXxSexual from './modules/anamCA/anamCAxASXxSexual';
import anamCAxASXxClarifications from './modules/anamCA/anamCAxASXxClarifications';
import anamCAxAALxAcademic from './modules/anamCA/anamCAxAALxAcademic';
import anamCAxAALxLabor from './modules/anamCA/anamCAxAALxLabor';
import anamCAxAALxClarifications from './modules/anamCA/anamCAxAALxClarifications';
import anamCAxCExSpecificCond from './modules/anamCA/anamCAxCExSpecificCond';
import anamCAxCExClarifications from './modules/anamCA/anamCAxCExClarifications';
import anamANxADxInfancy from './modules/anamAN/anamANxADxInfancy';
import anamANxADxChildhood from './modules/anamAN/anamANxADxChildhood';
import anamANxADxAdolescence from './modules/anamAN/anamANxADxAdolescence';
import anamANxADxSpecific from './modules/anamAN/anamANxADxSpecific';
import anamANxAFxFamilyMembers from './modules/anamAN/anamANxAFxFamilyMembers';
import anamANxALxAcademBasic from './modules/anamAN/anamANxALxAcademBasic';
import anamANxALxAcademSuperior from './modules/anamAN/anamANxALxAcademSuperior';
import anamANxALxLabor from './modules/anamAN/anamANxALxLabor';
import anamANxAPxMental from './modules/anamAN/anamANxAPxMental';
import anamANxAPxMedical from './modules/anamAN/anamANxAPxMedical';
import anamANxAPxDrugs from './modules/anamAN/anamANxAPxDrugs';
import anamANxAVxViolence from './modules/anamAN/anamANxAVxViolence';
import anamANxACxCriminal from './modules/anamAN/anamANxACxCriminal';
import anamANxMExMedications from './modules/anamAN/anamANxMExMedications';
import anamANxERxRelevantEvents from './modules/anamAN/anamANxERxRelevantEvents';
import anamANxClarifications from './modules/anamAN/anamANxClarifications';
import anamDSxDetailsSymptoms from './modules/anamCA/anamDSxDetailsSymptoms';
import anamDTxDiagTreatment from './modules/anamCA/anamDTxDiagTreatment';
import anamOGxGeneralObservation from './modules/anamCA/anamOGxGeneralObservation';

import testCOxList from './modules/test/testCOxList';
import testCorrectors from './modules/test/testCorrectors';
import testCOxResults from './modules/test/testCOxResults';
import testCOx01 from './modules/test/testCOx01';
import testCOx02 from './modules/test/testCOx02';
import testCOx03 from './modules/test/testCOx03';
import testCOx04 from './modules/test/testCOx04';
import testCOx05 from './modules/test/testCOx05';
import testCOx15 from './modules/test/testCOx15';
import testCOx16 from './modules/test/testCOx16';
import testCOx17 from './modules/test/testCOx17';
import testCOx18 from './modules/test/testCOx18';
import testCOx20 from './modules/test/testCOx20';
import testCOx35 from './modules/test/testCOx35';
import testCOx39 from './modules/test/testCOx39';
import testCOx41 from './modules/test/testCOx41';
import testCOx43 from './modules/test/testCOx43';
import testCOx44 from './modules/test/testCOx44';
import testCOx45 from './modules/test/testCOx45';
import testCOx46 from './modules/test/testCOx46';
import testCOx51 from './modules/test/testCOx51';
import testCOx52 from './modules/test/testCOx52';
import testCOx55 from './modules/test/testCOx55';
import proAppointmentsAPage from './modules/proHome/proAppointmentsAPage';
import proStatisticsA from './modules/proHome/proStatisticsA';
import proStatisticsB from './modules/proHome/proStatisticsB';

import homePacPage from './modules/patHome/homePacPage';
import homePatLegalPage from './modules/patHome/homePatLegalPage';
import authPat from './modules/patHome/authPat';
import patLoginPage from './modules/patHome/patLoginPage';
import patSignUpPage from './modules/patHome/patSignUpPage';
import patOTPPage from './modules/patHome/patOTPPage';
import patRePassPage from './modules/patHome/patRePassPage';
import patHomePage from './modules/patHome/patHomePage';
import patLegalPage from './modules/patHome/patLegalPage';
import patAccountPage from './modules/patHome/patAccountPage';
import patProfileAPage from './modules/patHome/patProfileAPaged';
import patRecordAPage from './modules/patHome/patRecordAPage';
import patRecordBPage from './modules/patHome/patRecordBPage';
import patAppointmentsAPage from './modules/patHome/patAppointmentsAPage';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

// Configuración de SecureLS
const ls = new SecureLS({
  isComprenssion: true,
  encryptionSecret: ENV.SECURE_LS_SECRET,
});
('use strict');

// Estado inicial por defecto
const getDefaultState = () => ({
  title: '',
});

export default new Vuex.Store({
  // strict: debug,
  plugins: [
    createPersistedState({
      key: 'rootS',
      paths: ['auth', 'authPat'],
      storage: {
        getItem: (key) => {
          try {
            return ls.get(key);
          } catch (e) {
            console.error('Error leyendo SecureLS en PWA:', e);
            return null; 
          }
        },
        setItem: (key, value) => {
          try {
            ls.set(key, value);
          } catch (e) {
            console.error('Error guardando en SecureLS:', e);
          }
        },
        removeItem: (key) => {
          try {
            ls.remove(key);
          } catch (e) {
            console.error('Error eliminando de SecureLS:', e);
          }
        },
      },
    }),
  ],

  state: getDefaultState(),

  getters: {
    title: (state) => state.title,
  },

  actions: {},
  
  mutations: {
    resetAnamData(state) {
      Object.keys(state).forEach((moduleKey) => {
        if (moduleKey.startsWith('anam') && state[moduleKey]) {
          Vue.set(state[moduleKey], 'dataCrud', []);
          Vue.set(state[moduleKey], 'dataCrud2', []);
          Vue.set(state[moduleKey], 'modelForm', {});
          Vue.set(state[moduleKey], 'modelList', []);
          Vue.set(state[moduleKey], 'modelSlides', []);
          Vue.set(state[moduleKey], 'checkboxNone', '');
          Vue.set(state[moduleKey], 'hasPermission', null);
          Vue.set(state[moduleKey], 'isNewRecord', true);
        }
      });
    },

    RESET_ALL(state) {      
      // Reset root state
      Object.assign(state, getDefaultState());

      // Reset módulos manualmente
      this.commit('auth/RESET_MODULE');
      this.commit('authPat/RESET_MODULE');
      
      // Borra datos persistidos
      ls.remove('rootS');      
    },
  },
  modules: {
    homeProPage,
    homeProLegalPage,
    auth,
    proLoginPage,
    proSignUpPage,
    proOTPPage,
    proRePassPage,
    usersCodeVerif,
    proHomePage,
    mainHeaderPlatA,
    proLegalPage,
    proAccountPage,
    proProfileAPage,
    proProfileBPage,
    proProfileCPage,
    proPatientsAPage,
    proPatientsBPage,
    proPatientsCPage,
    proPatientsCAnamnesisPage,
    proPatientsCReport,
    anamPermissions,
    notifications,
    anamLineData,
    anamFiliationPersonal,
    anamReasonConsultation,
    anamCAxInterview,
    anamCAxAFSMxPhysicalCond,
    anamCAxAFSMxDysfunction,
    anamCAxAFSMxPsychomotor,
    anamCAxAFSMxClarifications,
    anamCAxAFFxBasicHabits,
    anamCAxAFFxPhysiolSymptoms,
    anamCAxAFFxMuscularSymptoms,
    anamCAxAFFxClarifications,
    anamCAxACGxAttention,
    anamCAxACGxPerception,
    anamCAxACGxMemory,
    anamCAxACGxThoughtPt1,
    anamCAxACGxThoughtPt2,
    anamCAxACGxThoughtPt3,
    anamCAxACGxLanguage,
    anamCAxACGxClarifications,
    anamCAxARPxPersonality,
    anamCAxARPxClarifications,
    anamCAxAAMxAffectivity,
    anamCAxAAMxClarifications,
    anamCAxACOxBehavioral,
    anamCAxACOxClarifications,
    anamCAxAFAxFamiliarPt1,
    anamCAxAFAxFamiliarPt2,
    anamCAxAFAxFamiliarPt3,
    anamCAxAFAxClarifications,
    anamCAxASCxSocialPt1,
    anamCAxASCxSocialPt2,
    anamCAxASCxSocialPt3,
    anamCAxASCxSocialPt4,
    anamCAxASCxSocialPt5,
    anamCAxASCxSocialPt6,
    anamCAxASCxClarifications,
    anamCAxASXxSexual,
    anamCAxASXxClarifications,
    anamCAxAALxAcademic,
    anamCAxAALxLabor,
    anamCAxAALxClarifications,
    anamCAxCExSpecificCond,
    anamCAxCExClarifications,
    anamANxADxInfancy,
    anamANxADxChildhood,
    anamANxADxAdolescence,
    anamANxADxSpecific,
    anamANxAFxFamilyMembers,
    anamANxALxAcademBasic,
    anamANxALxAcademSuperior,
    anamANxALxLabor,
    anamANxAPxMental,
    anamANxAPxMedical,
    anamANxAPxDrugs,
    anamANxAVxViolence,
    anamANxACxCriminal,
    anamANxMExMedications,
    anamANxERxRelevantEvents,
    anamANxClarifications,
    anamDSxDetailsSymptoms,
    anamDTxDiagTreatment,
    anamOGxGeneralObservation,
    testCOxList,
    testCorrectors,
    testCOxResults,
    testCOx01,
    testCOx02,
    testCOx03,
    testCOx04,
    testCOx05,
    testCOx15,
    testCOx16,
    testCOx17,
    testCOx18,
    testCOx20,
    testCOx35,
    testCOx39,
    testCOx41,
    testCOx43,
    testCOx44,
    testCOx45,
    testCOx46,
    testCOx51,
    testCOx52,
    testCOx55,
    proAppointmentsAPage,
    proStatisticsA,
    proStatisticsB,

    homePacPage,
    homePatLegalPage,
    authPat,
    patLoginPage,
    patSignUpPage,
    patOTPPage,
    patRePassPage,
    patHomePage,
    patLegalPage,
    patAccountPage,
    patProfileAPage,
    patRecordAPage,
    patRecordBPage,
    patAppointmentsAPage,
  },
});
